import type { TrackingIdentifier } from '@ael/core-api';
import { Map } from 'immutable';
import type {
  OpenQuestionAnswerEntry,
  OpenQuestionAnswersForItems,
} from '../../../reducers/student/tracking/openQuestionAnswersReducer';

export type OpenQuestionAnswerEntryDTO = { a: string; q: string };
export type OpenQuestionAnswersForItemsDTO = Record<string, Record<string, OpenQuestionAnswerEntryDTO>>;

export const mapOpenQuestionAnswersToDto = (answers: OpenQuestionAnswersForItems): OpenQuestionAnswersForItemsDTO => {
  const data: OpenQuestionAnswersForItemsDTO = {};
  answers.forEach((widgetAnswers, contentItemId) => {
    const widgetObj: Record<string, OpenQuestionAnswerEntryDTO> = {};
    widgetAnswers.forEach((entry, widgetId) => {
      widgetObj[widgetId] = { a: entry.answer, q: entry.questionText };
    });
    data[contentItemId] = widgetObj;
  });
  return data;
};

export const mapOpenQuestionAnswersFromDto = (data: OpenQuestionAnswersForItemsDTO): OpenQuestionAnswersForItems => {
  let result = Map<TrackingIdentifier, Map<TrackingIdentifier, OpenQuestionAnswerEntry>>();
  for (const [contentItemId, widgetAnswers] of Object.entries(data)) {
    let widgetMap = Map<TrackingIdentifier, OpenQuestionAnswerEntry>();
    for (const [widgetId, value] of Object.entries(widgetAnswers)) {
      widgetMap = widgetMap.set(widgetId as TrackingIdentifier, { answer: value.a, questionText: value.q });
    }
    result = result.set(contentItemId as TrackingIdentifier, widgetMap);
  }
  return result;
};
